import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { roleChoiceSet } from 'reducers/user';
import { useRoleChoice } from 'utils/hooks';
import { RoleNames } from 'utils/constants';
import { texts } from 'utils/languages/fr';
import { RadioLabel } from 'components';
import { RadioGroup, Typography } from '@mui/material';

const DistributorRoleChoice = () => {
    const roleName = useRoleChoice();
    const dispatch = useDispatch();

    const handleChange = useCallback(e => dispatch(roleChoiceSet(e.target.value)), [dispatch]);

    return (
        <React.Fragment>
            <Typography variant="subtitle1" sx={{ mb: '20px' }}>
                {texts.DISTRIBUTOR_PEDAGOGIC_QUESTION}
            </Typography>
            <br></br>
            <RadioGroup
                row
                sx={{ display: 'flex', pl: 2, flexWrap: 'wrap', flexDirection: 'column' }}
                value={roleName}
                onChange={handleChange}
            >
                <RadioLabel value={RoleNames.ADMIN_CIF} label={texts.DISTRIBUTOR_PEDAGOGIC_CIF} />
                <RadioLabel value={RoleNames.PSI} label={texts.DISTRIBUTOR_PEDAGOGIC_PSI} />
            </RadioGroup>
        </React.Fragment>
    );
};

export default DistributorRoleChoice;
